// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"457":"f2d24eb9","822":"ea8b3135","954":"10f14769"}[chunkId] + ".chunk.js";
};